

import { Injectable } from '@angular/core';
import { DRtaLiquidacionReciboPago } from '@dian-api/recibo-pago490';
import { Subject } from 'rxjs';

@Injectable()
export class DEnvioDataServicio  {  

    private cambiaFlujo = new Subject<string>();
    public cambiaFlujo$ = this.cambiaFlujo.asObservable();

    private reciboPago = new Subject<DRtaLiquidacionReciboPago>();
    public reciboPago$ = this.reciboPago.asObservable();
    
    /**
    * @constructor
    */
    constructor(
    ){ }  

    
    
     /**
    * @desc Funcion para cambiar el paso en el que se encuentra el diligenciamiento del formulario 490
    * @param {string} item
    */
     enviarCambiarFlujo(item: string): void {
        this.cambiaFlujo.next(item);
      }


       /**
    * @desc Funcion para enviar número de formulario, fecha, año, periodicidad, periodo y cuota
    * @param {string} item
    */

      enviarDataFormulario(item: DRtaLiquidacionReciboPago): void {
        this.reciboPago.next(item);
      }


  
}


// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/recibo-pago/src/servicios/denvio-data.servcio.ts